import React from 'react';
import AccessForbidden from './AccessForbidden'
import hasAccess from './hasAccess';
import log from '../utils/console/log'

const AUTHORIZE_OVERRIDE = 'capAuthAuthorized';

const getPermissionToBeVerified = (options, props) => {
    const { permission, permissionParamMatch, paramToBeAssessed } = options;
    const { match = {} } = props;
    const { params = {}} = match;
    const param = params[paramToBeAssessed];
    if (permission) {
        return permission;
    }
    if (permissionParamMatch) {
        return permissionParamMatch[param] || AUTHORIZE_OVERRIDE;
    }
    return undefined;
}
/**
 * HOC to verify the authorize the component
 * Authorization of a component can happen in two ways
 * 1) By passing the permission option. If this value is passed, the entired component is accessed irrespective of location params
 * 2) By passing permissionParamMatch and paramToBeAssessed, here you can authorize the component based on specific param value
 * ex. Auth.authHoc(CampaignMessage, {
 *      RedirectComponent: CampaignHomePage,
 *      redirectPath: `${rootPath}/list`,
 *      paramToBeAssessed: 'mode',
 *      permissionParamMatch: {
 *        create: 'somethig',
 *      },
 *   })
 * @param {*} ComponentToBeVerified 
 * @param {*} options 
 */
const withAuth = (ComponentToBeVerified, options = {}) => {
    const getComponent = (permissionToBeVerified) => {
        const { RedirectComponent } = options;
        return (hasAccess(permissionToBeVerified) 
                || permissionToBeVerified === AUTHORIZE_OVERRIDE) ? 
                ComponentToBeVerified 
                : 
                (RedirectComponent || AccessForbidden);
    }
    const HOC = props => {
      const permissionToBeVerified = getPermissionToBeVerified(options, props);
      const VerifiedComponent = getComponent(permissionToBeVerified);
      return <VerifiedComponent {...props} />;
    };
    return HOC;
  };
  
  export default withAuth;